export enum OrderStatus {
    canceled      = "CANCELED",
    confirm       = "CONFIRM",
    shipped       = "SHIPPED",
    readyToPickup = "READY_TO_PICKUP",
    delivered     = "DELIVERED",
}
